<template>
    <div class="register-page">
        <el-button class="register-back" link @click="back">
            <el-icon><ArrowLeft /></el-icon>
            <span>返回</span>
        </el-button>

        <div class="register-card">
            <!-- 品牌区：桌面端位于左侧，移动端收为顶部条 -->
            <aside class="register-brand" @click="home">
                <!-- 吉祥物：密码框获得焦点时换戴眼镜形态 -->
                <img class="register-brand__mascot" alt="mascot" :src="mascotImage" />
                <h1 class="register-brand__name">hidoc</h1>
                <p class="register-brand__slogan">创建账号，开始沉淀你的知识</p>
            </aside>

            <!-- 表单区 -->
            <section class="register-panel">
                <header class="register-panel__head">
                    <h2 class="register-panel__title">创建账号</h2>
                    <p class="register-panel__subtitle">填写以下信息完成注册</p>
                </header>

                <el-form ref="form" :model="form" :rules="rules" status-icon label-position="top" class="register-form" @submit.prevent>
                    <el-form-item label="邮箱" prop="email">
                        <div class="register-form__row">
                            <el-input v-model="form.email" size="large" maxlength="64" placeholder="请输入公司邮箱"></el-input>
                            <el-button @click="getAuthCode">获取验证码</el-button>
                        </div>
                    </el-form-item>
                    <el-form-item label="验证码" prop="authCode">
                        <el-input v-model="form.authCode" size="large" maxlength="64" placeholder="请填写发送到您邮箱的验证码"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="realname">
                        <el-input v-model="form.realname" size="large" maxlength="16" placeholder="请输入您的姓名，中文名"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input id="password" type="password" v-model="form.password" size="large" maxlength="64" autocomplete="off" show-password placeholder="请输入密码，至少6位，可使用字母数字下划线" @focus="passwordFocused = true" @blur="passwordFocused = false"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="passwordConfirm">
                        <el-input type="password" v-model="form.passwordConfirm" size="large" maxlength="64" autocomplete="off" show-password placeholder="请再次输入密码，以确认准确无误" @focus="passwordFocused = true" @blur="passwordFocused = false"></el-input>
                    </el-form-item>
                    <el-button class="register-submit" type="primary" size="large" @click="onSubmit('form')">注册</el-button>
                </el-form>

                <footer class="register-panel__foot">
                    <el-link :underline="false" @click="login">已有账号，立即登录</el-link>
                </footer>
            </section>
        </div>
    </div>
</template>

<script>
import request from '../../utils/request.js';
import { ElMessageBox, ElMessage } from 'element-plus';
import { ArrowLeft } from '@element-plus/icons-vue';
export default {
    data() {
        return {
            form: {
                // 不再让用户选择，保留字段（提交空值）由后端随机分配
                avatar: '',
                // 不再让用户填写，保留字段是因为 store 的 register 会取 username.trim()，
                // 由后端根据邮箱自动生成账号
                username: '',
                realname: '',
                password: '',
                passwordConfirm: '',
                email: '',
                authCode: '',
                uid: ''
            },
            rules: {
                realname: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
                password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
                passwordConfirm: [{ required: true, message: '请再次输入密码', trigger: 'blur' }],
                email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }]
            },
            passwordFocused: false
        };
    },
    components: { ArrowLeft },
    computed: {
        // 密码框聚焦时用戴眼镜形态，未聚焦时用眼镜架在头上的形态
        mascotImage() {
            return this.passwordFocused ? require('../../assets/mascot/kip_sunglasses.png') : require('../../assets/mascot/kip_sunglasses_head.png');
        }
    },
    mounted() {
        document.title = '注册';
    },
    methods: {
        home() {
            this.$router.push({ path: '/', params: {} });
        },
        back() {
            this.$router.go(-1); //返回上一层
            // this.$router.push({ path: '/' });
        },
        login() {
            this.$router.push({ path: '/login', params: {} });
        },
        getAuthCode() {
            request({
                url: '/openapi/authcode/getForRegister',
                method: 'post',
                data: {
                    email: this.form.email,
                    token: ''
                }
            }).then(res => {
                if (res.code == 0) {
                    this.form.uid = res.meta.uid;

                    ElMessage({
                        message: '验证码已发送至邮箱，请查收',
                        type: 'success',
                        duration: 5 * 1000
                    });
                }
            });
        },
        onSubmit(formName) {
            console.log('submit!');
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$store
                        .dispatch('user/register', this.form)
                        .then(() => {
                            console.log(1);
                            this.$router.push({ path: this.redirect || '/', query: this.otherQuery });
                            // this.loading = false;
                        })
                        .catch(() => {
                            console.log(2);
                            // this.loading = false;
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.register-page {
    /* 局部覆盖主色，与登录页保持一致 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --register-text: #1f2d3d;
    --register-text-sub: #8a94a6;
    --register-line: #e6eaf0;

    position: relative;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    height: 100%;
    display: flex;
    /* 内容超出时允许滚动，配合卡片 margin:auto 实现居中且不被裁切 */
    overflow-y: auto;
    padding: 72px 24px 48px;
    color: var(--register-text);
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;
    background: radial-gradient(1200px 600px at 20% 0%, #ffffff 0%, rgba(255, 255, 255, 0) 60%), linear-gradient(160deg, #f6f8fc 0%, #eef2f9 100%);
}

.register-card {
    box-sizing: border-box;
    margin: auto;
    width: 100%;
    max-width: 960px;
    display: flex;
    overflow: hidden;
    background-color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.9);
    border-radius: 18px;
    box-shadow:
        0 18px 50px -12px rgba(28, 47, 84, 0.18),
        0 4px 12px rgba(28, 47, 84, 0.04);
}

/* ---------- 品牌区 ---------- */
.register-brand {
    flex: 0 0 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 48px 28px;
    text-align: center;
    cursor: pointer;
    user-select: none;
    border-right: 1px solid var(--register-line);
    background: linear-gradient(165deg, #eef4ff 0%, #e6eefc 55%, #e9f0fb 100%);
}

.register-brand__name {
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 1px;
    color: var(--register-text);
}

.register-brand__slogan {
    margin: 10px 0 0;
    font-size: 13px;
    letter-spacing: 0.5px;
    color: var(--register-text-sub);
}

.register-brand__mascot {
    width: 148px;
    height: 148px;
    object-fit: contain;
    margin: 0 0 26px;
    filter: drop-shadow(0 10px 22px rgba(40, 70, 140, 0.16));
}

/* ---------- 表单区 ---------- */
.register-panel {
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    flex-direction: column;
    padding: 40px 48px 32px;
}

.register-panel__head {
    margin-bottom: 20px;
}

.register-panel__title {
    margin: 0;
    font-size: 22px;
    font-weight: 600;
    letter-spacing: 0.3px;
    color: var(--register-text);
}

.register-panel__subtitle {
    margin: 8px 0 0;
    font-size: 13px;
    color: var(--register-text-sub);
}

/* ---------- 表单 ---------- */
.register-form :deep(.el-form-item) {
    margin-bottom: 18px;
}

.register-form :deep(.el-form-item__label) {
    padding-bottom: 6px;
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: var(--register-text-sub);
}

.register-form :deep(.el-input__wrapper) {
    padding: 1px 14px;
    border-radius: 10px;
    background-color: #f7f9fc;
    box-shadow: 0 0 0 1px var(--register-line) inset;
    transition:
        box-shadow 0.2s,
        background-color 0.2s;
}

.register-form :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.register-form :deep(.el-input__wrapper.is-focus) {
    background-color: #ffffff;
    box-shadow:
        0 0 0 1px var(--el-color-primary) inset,
        0 0 0 3px var(--el-color-primary-light-8);
}

/* 邮箱与「获取验证码」并排，避免按钮被挤到输入框下方 */
.register-form__row {
    display: flex;
    gap: 10px;
    width: 100%;

    :deep(.el-input) {
        flex: 1 1 auto;
        min-width: 0;
    }

    :deep(.el-button) {
        flex: 0 0 auto;
        margin-left: 0;
    }
}

.register-submit {
    width: 100%;
    height: 44px;
    margin-top: 6px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 500;
    letter-spacing: 1px;
    box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.65);
}

.register-panel__foot {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 16px;
    padding-top: 18px;
    border-top: 1px solid var(--register-line);
}

.register-panel__foot :deep(.el-link) {
    font-size: 13px;
}

/* ---------- 返回 ---------- */
.register-back {
    position: absolute;
    top: 20px;
    left: 24px;
    z-index: 1;
    font-size: 13px;
    color: var(--register-text-sub);
}

/* ---------- 移动端适配 ---------- */
@media (max-width: 768px) {
    .register-page {
        padding: 56px 16px 28px;
    }

    .register-card {
        max-width: 440px;
        flex-direction: column;
        border-radius: 14px;
        box-shadow: 0 10px 30px -12px rgba(28, 47, 84, 0.18);
    }

    .register-brand {
        flex: 0 0 auto;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        gap: 12px;
        padding: 14px 18px;
        text-align: left;
        border-right: none;
        border-bottom: 1px solid var(--register-line);
    }

    .register-brand__name {
        font-size: 18px;
    }

    .register-brand__slogan {
        display: none;
    }

    .register-brand__mascot {
        width: 56px;
        height: 56px;
        margin: 0;
    }

    .register-panel {
        padding: 22px 20px 20px;
    }

    .register-panel__title {
        font-size: 19px;
    }

    .register-back {
        top: 14px;
        left: 12px;
    }
}
</style>
